export default Object.freeze({
    VETERINARIAN: {
        id: 1,
        description: 'Medicamentos Veterinários',       
    },
    HUMAN: {
        id: 2,
        description: 'Medicamentos Humanos',
    },
    getDescription(id){
        if (id == this.VETERINARIAN.id) return this.DOG.description;
        return this.HUMAN.description;
    },
});